module.exports = __webpack_public_path__ + "img/rockwell.77d56399.jpg";